import { render, staticRenderFns } from "./DesignTrackerExtend.vue?vue&type=template&id=0dbcdfd4&"
import script from "./DesignTrackerExtend.vue?vue&type=script&lang=js&"
export * from "./DesignTrackerExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports